
import React, { useContext } from 'react';
import classNames from 'classnames';

import { I18nContext } from '@bingads-webui-react/i18n-context';
import { withCustomValidation, withError } from '@bingads-webui-react/validation';
import { withControlErrorHandling } from '@bingads-webui-campaign-react/error-handling';
import { withAlwaysShowError } from '@bingads-webui-campaign-react/form-error';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { BusinessNameWithValidation } from '@bingads-webui-campaign-react/business-name';

import { getBusinessNameStyles } from './business-name-styles';

const InternalBusinessName = React.memo((props) => {
  const i18n = useContext(I18nContext);
  const classes = useDefaultStyles(getBusinessNameStyles);

  return (
    <div className={classNames('business-name-section', classes.container)}>
      <BusinessNameWithValidation i18n={i18n} {...props} />
    </div>
  );
});

export const BusinessName
  = withControlErrorHandling(withAlwaysShowError(withError(withCustomValidation(InternalBusinessName))));
